
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/csr",
      function () {
        return require("private-next-pages/about/csr.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/csr"])
      });
    }
  